/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Aggregated tool usage metrics for one MCP client and tool
 */
export type ToolUsageClientToolBreakdownRow = {
  /**
   * Stable MCP client identity used by filters and chart grouping
   */
  clientKey: string;
  /**
   * User-facing label for the MCP client
   */
  clientLabel: string;
  /**
   * Total number of tool usage events for the MCP client and tool
   */
  eventCount: number;
  /**
   * Number of failed tool usage events for the MCP client and tool
   */
  failureCount: number;
  /**
   * Fraction of completed tool usage events for the MCP client and tool that failed
   */
  failureRate: number;
  /**
   * Number of successful tool usage events for the MCP client and tool
   */
  successCount: number;
  /**
   * Observed tool name
   */
  toolName: string;
};

/** @internal */
export const ToolUsageClientToolBreakdownRow$inboundSchema: z.ZodMiniType<
  ToolUsageClientToolBreakdownRow,
  unknown
> = z.pipe(
  z.object({
    client_key: z.string(),
    client_label: z.string(),
    event_count: z.int(),
    failure_count: z.int(),
    failure_rate: z.number(),
    success_count: z.int(),
    tool_name: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "client_key": "clientKey",
      "client_label": "clientLabel",
      "event_count": "eventCount",
      "failure_count": "failureCount",
      "failure_rate": "failureRate",
      "success_count": "successCount",
      "tool_name": "toolName",
    });
  }),
);

export function toolUsageClientToolBreakdownRowFromJSON(
  jsonString: string,
): SafeParseResult<ToolUsageClientToolBreakdownRow, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ToolUsageClientToolBreakdownRow$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ToolUsageClientToolBreakdownRow' from JSON`,
  );
}
